<template>
    <div class="index">
        <h1>关系图谱</h1>
        <div class="list">
            <ul>
                <router-link tag="li" v-for="item in relation" :to="'/relation/'+item.id">
                    <div class="pic">
                        <i class="picI"><img :src="item.pic"> </i>
                        <div class="tools">
                            <i class="edit el-icon-s-tools" @click.stop="edit(item)"></i>
                            <i class="edit el-icon-delete-solid" @click.stop="del(item)" v-if="item.del"></i>
                        </div>
                    </div>
                    <div class="title">
                        {{item.title}}
                    </div>
                </router-link>
                <li class="add" @click="add"><i class="el-icon-plus"></i></li>
            </ul>
        </div>
        <el-dialog
                :title="whichTitle"
                :visible.sync="showEditDialog"
                :close-on-click-modal="false"
        >
            <el-form :model="editForm" status-icon :rules="rules" ref="editForm" label-width="80px">
                 <el-form-item label="封面图片" prop="pic">
                    <el-upload
                            class="avatar-uploader" :class="{tx:editForm.pic}"
                            action="https://jsonplaceholder.typicode.com/posts/"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload">
                        <template v-if="editForm.pic">
                            <img :src="editForm.pic" class="avatar">
                            <i class="el-icon-delete" @click.stop="handleRemove"></i>
                        </template>
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                    <el-input v-model="editForm.pic"></el-input>
                </el-form-item>
                <el-form-item label="图谱名称" prop="title">
                    <el-input v-model="editForm.title"></el-input>
                </el-form-item>
                <el-form-item label="删除可否">
                    <el-checkbox v-model="editForm.del"></el-checkbox>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm('editForm')">提交</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: 'index',
        data() {
            let validateTitle = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入关系图谱名称'));
                } else {
                    callback();
                }
            };
            let validatePic = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请上传图片'));
                } else {
                    callback();
                }
            };
            return {
                relation: null,
                showEditDialog: false,
                currentRelation: null,
                editMode: 'add', // 'add' 或 'edit'
                editForm: {
                    title: '',
                    del: false,
                    pic: '',
                    id: ''
                },
                rules: {
                    title: [
                        {required: true, validator: validateTitle, trigger: 'blur'}
                    ],
                    // pic: [
                    //     {required: true, validator: validatePic, trigger: 'blur'}
                    // ],
                },
            }
        },
        mounted() {
            if (this.$store.state.relation.relation === null) {
                this.$store.dispatch('relation/getAll').then((rs) => {
                    this.relation = rs
                })
            } else {
                this.relation = this.$store.state.relation.relation
            }
        },
        watch: {},
        computed: {
            whichTitle() {
                if (this.editMode === 'edit') {
                    return '修改关系图谱'
                } else {
                    return '新建一个关系图谱'
                }
            }
        },
        methods: {
            add() {
                this.editForm.title = ''
                this.editForm.pic = ''
                this.editForm.del = false
                this.editForm.id = ''
                this.editMode = 'add'
                this.showEditDialog = true
            },
            edit(item) {
                this.editMode = 'edit'
                this.editForm.title = item.title
                this.editForm.pic = item.pic
                this.editForm.del = item.del
                this.editForm.id = item.id
                this.showEditDialog = true
                this.currentRelation = item
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.saveEdit()
                    } else {
                        return false;
                    }
                });
            },
            async saveEdit() {
                if (this.editMode === 'add') {
                    let id = this.getId()
                    this.relation.unshift({
                        title: this.editForm.title,
                        pic: this.editForm.pic,
                        del: this.editForm.del,
                        id
                    })
                    await this.$supabase.from('relation').insert({
                        id,
                        title: this.editForm.title,
                        del: this.editForm.del,
                        pic: this.editForm.pic,
                    })
                    this.$message({
                        message: '添加成功',
                        type: 'success'
                    });

                } else if (this.editMode === 'edit') {
                    this.currentRelation.title = this.editForm.title
                    this.currentRelation.pic = this.editForm.pic
                    this.currentRelation.del = this.editForm.del
                    await this.$supabase.from('relation').update({
                        title: this.editForm.title,
                        pic: this.editForm.pic,
                        del: this.editForm.del
                    }).eq('id', this.editForm.id)
                    this.$message({
                        message: '修改除成功',
                        type: 'success'
                    });
                }
                this.showEditDialog = false
                await this.$store.dispatch('relation/getAll')
            },
            del(data) {
                this.$confirm('确认删除该关系图谱?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let index = this.relation.indexOf(data)
                    this.relation.splice(index, 1)
                    this.delD(data)
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },
            async delD(data) {
                await this.$supabase
                    .from('relation')
                    .delete()
                    .eq('id', data.id)
                await this.$store.dispatch('relation/getAll')
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            },
            getId() {
                let id
                if (this.relation.length > 0) {
                    let maxObject = this.relation.reduce((prev, current) => (prev.id > current.id ? prev : current));
                    id = maxObject.id + 1
                } else {
                    id = 1
                }
                return id
            },
            async handleRemove() {
                this.editForm.pic = ''
                let arr = this.currentRelation.pic.split('/')
                let len = arr.length
                const {data} = await this.$supabase
                    .storage
                    .from('my')
                    .remove(arr[len - 1])
                this.$message.success('图片删除成功！');
            },
            async handleAvatarSuccess(res, file) {
                //this.editForm.photo = URL.createObjectURL(file.raw);
                const {error} = await this.$supabase
                    .storage
                    .from('my')
                    .upload(file.name, file.raw)
                if (error) {
                    this.$message.error(error);
                } else {
                    this.$message.success('图片上传成功！');
                    const {data} = await this.$supabase
                        .storage
                        .from('my')
                        .getPublicUrl(file.name)
                    this.editForm.pic = data.publicUrl
                }

            },
            beforeAvatarUpload(file) {
                let types = ['image/jpeg', 'image/png', 'image/gif']
                const isJPG = types.indexOf(file.type) > -1;
                const isLt2M = file.size / 1024 / 1024 < 2;

                if (!isJPG) {
                    this.$message.error('上传头像只能是jpg,png,gif图片格式!');
                }
                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过2MB!');
                }
                return isJPG && isLt2M;
            },


        }
    }
</script>
<style scoped>
    .index {
        width: 100%;
        max-width: 1200px;
        margin: 0 auto;
        padding: 15px;
        display: flex;
        flex-direction: column;
        gap: 2vw
    }

    .index h1 {
        font-size: clamp(30px, 3vw, 50px);
        font-weight: 700;
        padding-top: 3vw;
    }


    .index .list ul {
        display: flex;
        align-items: stretch;
        flex-wrap: wrap;
        gap: 1vw;
        width: calc(100% + 1vw);
    }

    .index .list ul li {
        background: var(--white);
        width: calc(25% - 1vw);
        border-radius: 2px;
        position: relative;
        cursor: pointer;
    }

    .index .list ul li .pic {
        display: flex;
        position: relative;
    }

    .index .list ul li .pic i.picI {
        width: 100%;
        padding-bottom: 46%;
        position: relative;
    }

    .index .list ul li .pic i.picI img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        position: absolute;
    }

    .index .list ul li .title {
        padding: 10px 10px;
    }

    .index .list ul li .tools {
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 5px;
        z-index: 1;
        opacity: 0;
    }

    .index .list ul li .tools i {
        font-size: calc(clamp(30px, 3vw, 50px) * 0.4);
        width: calc(clamp(30px, 3vw, 50px) * 0.6);
        height: calc(clamp(30px, 3vw, 50px) * 0.6);
        display: flex;
        align-items: center;
        justify-content: center;
        color: var(--white);
        position: relative;
        z-index: 1;
        background: rgba(0, 0, 0, .8);
        border-radius: 100%;
    }


    .index .list ul li .pic:hover .tools:before {
        position: absolute;
        width: 100%;
        height: 100%;
        content: '';
        background: rgba(0, 0, 0, .6);
    }

    .index .list ul li .pic:hover .tools {
        opacity: 1;
    }


    .index .list ul li.add {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .index .list ul li.add i {
        font-size: 3vw;
        color: #5F92BDFF;
    }


    @media (max-width: 768px) {
        .index .list ul {
            gap: 3vw;
            width: calc(100% + 3vw);

        }

        .index .list ul li {
            width: calc(50% - 3vw);
        }

        .index .list ul li.add i {
            font-size: 6vw;
        }

    }
</style>

